import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AngularProgressItem } from '../../models';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    moduleId: module.id,
    selector: 'angular-progress-steps',
    templateUrl: 'angular-progress-steps.html'
})
export class AngularProgressStepsComponent {
    @Input() itemList: AngularProgressItem[] = new Array<AngularProgressItem>();   
    @Input() classMini:boolean = false;
    @Input() lenStep: number = 2; 
    @Output() onNodeClickEmitter = new EventEmitter<AngularProgressItem>();
    constructor(private domSanitizer: DomSanitizer) {
    }
    getDescrizione(descrizione)
    {
        return  this.domSanitizer.bypassSecurityTrustHtml(descrizione);
    }
    onNodeClick(item :AngularProgressItem ) {        
        this.onNodeClickEmitter.emit(item);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/progress-steps/angular-progress-steps.component.ts